import { useViaduckEnabled } from "duck/api/hooks";
import { useDuck } from "duck/ui/chat/contexts/DuckContext";
import { useDuckFullscreen } from "duck/ui/chat/hooks/useDuckFullscreen";

import DuckButton from "./DuckButton";

const DuckHeaderAction = () => {
  const isViaDuckEnabled = useViaduckEnabled();

  if (!isViaDuckEnabled) {
    return null;
  }

  return <DuckHeaderActionInner />;
};

const DuckHeaderActionInner = () => {
  const { open, setOpen } = useDuck();
  const { isFullscreen } = useDuckFullscreen();

  if (isFullscreen) {
    return null;
  }

  return <DuckButton onClick={() => setOpen(!open)} isActive={open} />;
};

export default DuckHeaderAction;
